import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getUsersCountRequest, getUsersCountRequestError, getUsersCountRequestSuccess } from "../../slices/user-management/CountSlice";

export const GetUsersCountAPI = () => async (dispatch) => {
    try {
        dispatch(getUsersCountRequest());
        axiosInstance({
            method: "GET",
            url: endpoints.usersCount,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getUsersCountRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getUsersCountRequestError(_error));
            });
    } catch (error) { }
};
